import * as React from "react";
import { motion } from "framer-motion";

function SvgDinoHero(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 1873 770"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      {...props}
    >
      <g transform="translate(206 194.64) scale(1.27972)">
        <g id="dino_hero_svg__front">
          <g id="dino_hero_svg__plant_back">
            <path
              d="M265.24 970.652c7.159-23.452 16.826-46.198 28.882-67.954"
              fill="none"
              stroke="#66a09e"
              strokeWidth={10.19}
              transform="matrix(.2513 -.18402 .17856 .24384 334.088 -135.113)"
            />
            <path
              d="M564.934 55.185c1.105-7.854 3.193-15.232 6.17-22.079"
              fill="none"
              stroke="#bcdad1"
              strokeWidth={3.1256546999999997}
            />
            <path
              d="M262.846 973.285a260.057 260.057 0 012.522-11.831"
              fill="none"
              stroke="#bcdad1"
              strokeWidth={8.71}
              transform="matrix(.35606 .04335 -.04335 .35606 519.814 -324.634)"
            />
          </g>
          <g id="dino_hero_svg__front_text">
            <path
              d="M.127-.7h.636a.027.027 0 01.027.027v.152a.027.027 0 01-.027.027H.37v.064h.328a.027.027 0 01.027.027v.151a.027.027 0 01-.027.027H.37v.198A.027.027 0 01.343 0H.127A.027.027 0 01.1-.027v-.646A.027.027 0 01.127-.7z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 -196.681 101.493)"
            />
            <path
              d="M.822-.031a.03.03 0 01.002.011.018.018 0 01-.006.013A.021.021 0 01.802 0H.575C.555 0 .541-.008.533-.025L.445-.223H.361v.196A.027.027 0 01.334 0H.118a.027.027 0 01-.027-.027v-.646A.027.027 0 01.118-.7h.389c.091 0 .164.022.217.065.053.043.08.102.08.177 0 .091-.035.156-.105.197l.123.23zM.361-.514v.106h.125A.04.04 0 00.52-.423a.052.052 0 00.012-.036.071.071 0 00-.011-.039.043.043 0 00-.035-.016H.361z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 106.913 101.493)"
            />
            <path
              d="M.797-.409v.118a.277.277 0 01-.05.168.27.27 0 01-.131.096.578.578 0 01-.191.028.578.578 0 01-.191-.028.27.27 0 01-.131-.096.278.278 0 01-.05-.169v-.116c0-.098.034-.171.104-.22a.452.452 0 01.268-.073c.11 0 .2.024.269.073a.253.253 0 01.103.219zM.323-.426v.152a.07.07 0 00.027.059.123.123 0 00.075.021A.123.123 0 00.5-.215a.072.072 0 00.027-.06v-.15A.072.072 0 00.5-.485a.123.123 0 00-.075-.021.123.123 0 00-.075.021.07.07 0 00-.027.059z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 410.507 101.493)"
            />
            <path
              d="M.552-.7h.186a.027.027 0 01.027.027v.646A.027.027 0 01.738 0H.577a.049.049 0 01-.04-.021L.319-.299v.272A.027.027 0 01.292 0H.106a.027.027 0 01-.027-.027v-.646A.027.027 0 01.106-.7h.162c.016 0 .029.007.039.02l.218.301v-.294A.027.027 0 01.552-.7z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 714.1 101.493)"
            />
            <path
              d="M.08-.7h.69a.027.027 0 01.027.027v.161a.027.027 0 01-.027.027H.555v.458A.027.027 0 01.528 0H.322a.027.027 0 01-.027-.027v-.458H.08a.027.027 0 01-.027-.027v-.161A.027.027 0 01.08-.7z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 1017.697 101.493)"
            />
          </g>
          <g id="dino_hero_svg__plant_front">
            <path
              d="M294.392 902.318c30.402-54.867 75.723-103.059 134.569-140.789"
              fill="none"
              stroke="#66a09e"
              strokeWidth={7.42}
              transform="matrix(.34516 -.25275 .24525 .33492 246.24 -197.542)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-4.142 27.113-9.243 27.113-5.102 0-9.244-8.001-9.244-27.113 0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.51214 .1917 -.11203 .27797 440.094 -345.626)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.33431 .38585 -.2546 .21848 622.515 -365.195)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.31784 .39426 -.29564 .22895 653.54 -349.668)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.55242 .38234 -.25291 .34774 519.762 -404.046)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.42681 .42596 .29903 .30278 527.128 -388.095)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.4579 .217 .15578 .34746 649.134 -362.152)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.43957 .07706 .04871 .32404 727.507 -311.43)"
            />
            <g>
              <path
                d="M265.368 961.454c19.626-82.596 79.337-154.61 163.593-199.925"
                fill="none"
                stroke="#bcdad1"
                strokeWidth={8.71}
                transform="matrix(.35104 .0737 -.0737 .35104 550.499 -327.789)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-4.142 27.113-9.243 27.113-5.102 0-9.244-8.001-9.244-27.113 0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(.10428 .40813 -.24995 .06386 788.337 -257.342)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(-.0553 .43157 -.25055 -.0321 845.722 -186.27)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(.0039 .43991 -.30172 .00267 836.539 -204.833)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(-.02139 .48822 -.36215 -.01586 873.459 -195.8)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(-.48094 -.0087 -.0065 .3593 803.693 -264.332)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(-.56113 .11606 .08183 .39566 754.27 -322.036)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(.01996 .54803 -.3977 .01448 867.748 -220.146)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(-.4284 -.04362 -.03308 .32485 820.95 -241.017)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#bcdad1"
                transform="matrix(-.37171 -.12034 -.08191 .25301 855.181 -164.51)"
              />
            </g>
          </g>
        </g>
        <g id="dino_hero_svg__end">
          <g id="dino_hero_svg__plant_back1">
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(-.57199 .25494 .1712 .38411 1304.45 -10.835)"
            />
            <path
              d="M258.694 1046.24c-.771-16.77-.098-33.31 1.97-49.532"
              fill="none"
              stroke="#66a09e"
              strokeWidth={12.24}
              transform="matrix(-.33444 .06277 .07773 .41418 1190.26 -63.769)"
            />
            <path
              d="M1185.226 393.218a103.853 103.853 0 0010.235-27.814"
              fill="none"
              stroke="#bcdad1"
              strokeWidth={4.688247}
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.14832 .60297 .39958 .1925 946.103 -23.263)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.37447 .422 -.2105 .28265 1182.47 -13.615)"
            />
          </g>
          <g id="dino_hero_svg__end_text">
            <path
              d="M.35-.195h.399a.027.027 0 01.027.027v.141A.027.027 0 01.749 0H.117A.027.027 0 01.09-.027v-.646A.027.027 0 01.117-.7h.622a.027.027 0 01.027.027v.141a.027.027 0 01-.027.027H.35v.063h.334a.027.027 0 01.027.027v.13a.027.027 0 01-.027.027H.35v.063z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 411.719 449.193)"
            />
            <path
              d="M.552-.7h.186a.027.027 0 01.027.027v.646A.027.027 0 01.738 0H.577a.049.049 0 01-.04-.021L.319-.299v.272A.027.027 0 01.292 0H.106a.027.027 0 01-.027-.027v-.646A.027.027 0 01.106-.7h.162c.016 0 .029.007.039.02l.218.301v-.294A.027.027 0 01.552-.7z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 715.313 449.193)"
            />
            <path
              d="M.103-.7h.319c.073 0 .137.01.191.029a.267.267 0 01.181.27v.102c0 .107-.036.184-.108.233A.47.47 0 01.422 0H.103a.027.027 0 01-.027-.027v-.646A.027.027 0 01.103-.7zm.233.195v.31h.091a.113.113 0 00.074-.023.075.075 0 00.028-.063v-.138a.077.077 0 00-.028-.064.113.113 0 00-.074-.022H.336z"
              fill="#bfb2af"
              fillRule="nonzero"
              transform="matrix(357.16976 0 0 357.16976 1018.907 449.193)"
            />
          </g>
          <g id="dino_hero_svg__plant_front1">
            <path
              d="M294.073 893.17c28.493-52.109 73.901-97.438 134.888-131.641"
              fill="none"
              stroke="#bcdad1"
              strokeWidth={12.9}
              transform="matrix(-.27544 -.23709 -.23709 .27544 1488.22 189.106)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-4.142 27.113-9.243 27.113-5.102 0-9.244-8.001-9.244-27.113 0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(-.4664 .18166 .09832 .25242 1320.499 25.412)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(-.235 .34918 .2365 .15916 1116.545 39.165)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(-.3527 .28484 .20028 .248 1198.557 26.665)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(-.47501 .318 .20432 .3052 1246.652 -4.811)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(.3205 .4713 -.30108 .20475 1284.472 5.031)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(.43325 .2376 -.15959 .291 1130.86 14.91)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#bcdad1"
              transform="matrix(.31126 .20539 -.157 .23793 1178.443 42.059)"
            />
            <g>
              <path
                d="M260.664 996.708c12.049-94.53 71.446-178.275 168.297-235.179"
                fill="none"
                stroke="#66a09e"
                strokeWidth={12.24}
                transform="matrix(-.33444 .06277 .07773 .41418 1190.263 -63.77)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-4.142 27.113-9.243 27.113-5.102 0-9.244-8.001-9.244-27.113 0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(-.11483 .51346 .29668 .1243 931.498 -42.03)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.06231 .51123 .3103 -.02713 858.091 85.22)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.14599 .50987 .30485 -.04292 847.788 113.713)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.05754 .64505 .35945 .02775 862.831 23.684)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.52316 .01509 -.0279 .4207 955.137 .857)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.49986 .25912 -.13983 .38974 1066.085 -55.87)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(-.08499 .6351 .36167 .13006 937.638 -22.099)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.5103 -.1479 .04948 .37185 883.764 85.345)"
              />
              <path
                d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
                fill="#66a09e"
                transform="matrix(.43863 -.28122 .12335 .29364 837.174 185.73)"
              />
            </g>
          </g>
        </g>
        <g
          id="dino_hero_svg__coffee"
          transform="matrix(-.83795 0 0 .83795 348.152 -221.354)"
        >
          <path
            d="M3316.8 2533.78h-38.19l6.04-36.92h26.11l6.04 36.92z"
            fill="#c45b5b"
            transform="rotate(180 2327.725 2104.67) scale(1.39727)"
          />
          <path
            d="M3316.8 2533.78h-38.19l2.89-36.92h32.41l2.89 36.92z"
            fill="#feb4b2"
            transform="matrix(-1.39727 0 0 .25743 4655.45 16.688)"
          />
          <path
            d="M3316.8 2533.78h-38.19l2.89-36.92h32.41l2.89 36.92z"
            fill="#feb4b2"
            transform="matrix(-.26097 0 0 .0977 923.59 412.711)"
          />
          <path
            d="M3316.65 2531.9c.03.46-.02.94-.14 1.3-.13.37-.32.58-.52.58h-36.57c-.2 0-.39-.21-.52-.58a3.38 3.38 0 01-.14-1.3c.51-6.55 2.21-28.2 2.64-33.74.06-.76.33-1.3.66-1.3h31.29c.33 0 .6.54.66 1.3.43 5.54 2.13 27.19 2.64 33.74z"
            fill="#feb4b2"
            transform="matrix(-1.39727 0 0 -.5857 4655.45 2164.81)"
          />
          <motion.g
            animate={{
              scaleY: [1, 0.8, 1],
              scaleX: [1, 0.8, 1],
            }}
            transition={{
              duration: 3,
              loop: Infinity,
              ease: "easeInOut",
            }}
          >
            <path
              d="M3271.41 2513.86c-1.46-4.04-2.24-7.48-2.79-10.6-.44-2.56-.56-4.78-.52-6.82.03-1.44.2-2.75.42-3.99.24-1.35.6-2.6 1.01-3.78.96-2.83 2.23-5.32 3.66-7.63 2.52-4.44 3.71-7.82 3.35-11.09-.35-3.18-1.98-6.17-5.27-9.73a.384.384 0 00-.53-.09c-.17.12-.21.36-.09.53 2.03 3.7 2.88 6.51 2.56 9.28-.3 2.56-1.84 4.91-4.49 7.93-1.44 1.74-2.88 3.56-4.08 5.64-.52.9-.97 1.84-1.36 2.85-.62 1.59-1.07 3.32-1.26 5.19a21.4 21.4 0 00.1 5.28 28.59 28.59 0 002.29 7.73c1.39 3.03 3.36 6.19 6.09 9.8.14.25.45.34.71.2a.51.51 0 00.2-.7z"
              fill="#bfb2af"
              transform="matrix(-.93254 0 0 .93254 3112.76 -1696.29)"
              id="dino_hero_svg__smoke"
            />
          </motion.g>
        </g>
        <g id="dino_hero_svg__plants">
          <path
            d="M291.451 899.885c28.694-54.334 75.401-101.864 137.51-138.356"
            fill="none"
            stroke="#bcdad1"
            strokeWidth={10.22}
            transform="matrix(.16817 -.25559 .25559 .16817 -67.413 307.824)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-4.142 27.113-9.243 27.113-5.102 0-9.244-8.001-9.244-27.113 0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(.39115 .0366 -.0235 .25128 45.305 118.8)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(.26576 .23057 -.15727 .18127 203.307 102.73)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(.34475 .18675 -.12782 .23596 149.672 102.038)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(.38565 .10162 -.07878 .29899 103.507 113.494)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(-.22038 .35006 .2594 .1633 109.656 108.363)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(-.28258 .2631 .1904 .20449 181.68 93.104)"
          />
          <path
            d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
            fill="#bcdad1"
            transform="matrix(-.24453 .24176 .16872 .17066 177.954 105.8)"
          />
          <g>
            <path
              d="M258.694 1046.24c-5.263-114.531 56.797-218.043 170.267-284.711"
              fill="none"
              stroke="#66a09e"
              strokeWidth={9.87}
              transform="matrix(.31333 -.04556 .04556 .31333 90.56 88.447)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-4.142 27.113-9.243 27.113-5.102 0-9.244-8.001-9.244-27.113 0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.23432 .3193 -.176 .12916 289.56 68.831)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.08527 .37448 -.25236 .05746 402.964 111.62)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.06917 .38212 -.29697 .05376 429.368 128.47)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.20308 .46056 -.29278 .1291 357.354 57.84)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.40124 .1389 .11102 .32074 313.658 52.469)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.43376 .26911 .17668 .28478 271.98 47.338)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(.25553 .37278 -.28975 .19861 326.933 65.919)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.40621 -.01608 -.01237 .31249 418.712 104.971)"
            />
            <path
              d="M440.233 693.616c5.101 0 9.243 23.032 9.243 42.143 0 19.112-7.481 26.304-12.583 26.304s-5.904-7.192-5.904-26.304c0-19.111 4.142-42.143 9.244-42.143z"
              fill="#66a09e"
              transform="matrix(-.39524 .01512 .00944 .24659 414.267 123.086)"
            />
          </g>
        </g>
        <g
          id="dino_hero_svg__dino"
          transform="matrix(-.55925 0 0 .55925 342.932 -70.138)"
        >
          <path
            d="M451.534 400.366c-2.552-16.816 25.989-41.52 34.764-45.356 8.742-3.821 23.682 14.783 17.888 22.343-5.794 7.559-51.543 27.653-52.652 23.013z"
            fill="#fd6a66"
            transform="matrix(-1.01882 .01373 .0156 1.22438 1102.66 -83.005)"
          />
          <path
            d="M486.317 387.488c-.887-6.626 30.136-49.452 52.13-48.285 9.666.513 14.008 31.706 5.32 39.754-8.688 8.047-56.563 15.157-57.45 8.531z"
            fill="#fd6a66"
            transform="matrix(-1.14526 .01543 .01702 1.3356 1171.66 -124.239)"
          />
          <g id="dino_hero_svg__tail">
            <motion.g
              style={{
                originY: 0,
                originX: 0,
              }}
              animate={{
                rotate: [0, 5],
              }}
              transition={{
                duration: 2,
                yoyo: Infinity,
                ease: "easeInOut",
              }}
            >
              <path
                d="M486.317 387.488c-.887-6.626 30.136-49.452 52.13-48.285 9.666.513 14.008 31.706 5.32 39.754-8.688 8.047-56.563 15.157-57.45 8.531z"
                fill="#fd6b67"
                transform="matrix(.56652 .57507 -.70618 .69671 781.714 143.754)"
              />
              <path
                d="M486.317 387.488c-.887-6.626 30.136-49.452 52.13-48.285 9.666.513 14.008 31.706 5.32 39.754-8.688 8.047-56.563 15.157-57.45 8.531z"
                fill="#fd6b67"
                transform="matrix(.677 .62081 -.78365 .85582 716.679 27)"
              />
              <path
                d="M486.317 387.488c-.887-6.626 30.136-49.452 52.13-48.285 9.666.513 14.008 31.706 5.32 39.754-8.688 8.047-56.563 15.157-57.45 8.531z"
                fill="#fd6b67"
                transform="matrix(.78267 .4808 -.61611 1.0046 563.867 12.885)"
              />
              <path
                d="M486.317 387.488c-.887-6.626 30.136-49.452 52.13-48.285 9.666.513 14.008 31.706 5.32 39.754-8.688 8.047-56.563 15.157-57.45 8.531z"
                fill="#fd6b67"
                transform="matrix(.34204 .41902 -.48285 .39473 879.946 389.602)"
              />
              <path
                d="M486.317 387.488c-.887-6.626 30.136-49.452 52.13-48.285 9.666.513 14.008 31.706 5.32 39.754-8.688 8.047-56.563 15.157-57.45 8.531z"
                fill="#fd6b67"
                transform="matrix(.42123 .51603 -.60797 .49702 858.525 276.69)"
              />
              <path
                d="M364.457 585.486c11.192.086 3.174 27.521.162 58.819-3.333 34.638-12.579 103.606 1.45 144.504 6.903 20.125-89.051-34.526-89.248-58.104-.444-77.091 43.249-145.557 87.636-145.219z"
                fill="#fe9f9c"
                transform="matrix(1.34581 -1.19247 -.67005 -.75621 790.755 1651.685)"
              />
              <g transform="matrix(1.34581 -1.19247 -.67005 -.75621 790.755 1651.685)">
                <clipPath id="dino_hero_svg___clip1">
                  <path d="M364.457 585.486c11.192.086 3.174 27.521.162 58.819-3.333 34.638-12.579 103.606 1.45 144.504 6.903 20.125-89.051-34.526-89.248-58.104-.444-77.091 43.249-145.557 87.636-145.219z" />
                </clipPath>
                <g clipPath="url(#dino_hero_svg___clip1)">
                  <ellipse
                    cx={716.185}
                    cy={713.203}
                    rx={33.711}
                    ry={33.625}
                    fill="#fe8c89"
                    transform="matrix(-.26043 .19547 .2119 .28233 384.478 266.859)"
                  />
                  <ellipse
                    cx={716.185}
                    cy={713.203}
                    rx={33.711}
                    ry={33.625}
                    fill="#fe8c89"
                    transform="matrix(-.10663 .08003 .10961 .14604 349.845 469.878)"
                  />
                  <ellipse
                    cx={716.185}
                    cy={713.203}
                    rx={33.711}
                    ry={33.625}
                    fill="#fe8c89"
                    transform="matrix(-.13048 .09793 .13072 .17416 314.07 462.278)"
                  />
                </g>
              </g>
            </motion.g>
          </g>
          <path
            d="M750.852 777.401c-10.707 70.062-406.486 69.456-415.076 0-10.189-82.382-3.493-186.567 1.556-214.876 18.487-103.632 100.716-192.791 205.982-193.322 105.266.531 187.495 89.69 205.981 193.322 5.05 28.309 14.097 132.819 1.557 214.876z"
            fill="#feb4b2"
          />
          <clipPath id="dino_hero_svg___clip2">
            <path d="M750.852 777.401c-10.707 70.062-406.486 69.456-415.076 0-10.189-82.382-3.493-186.567 1.556-214.876 18.487-103.632 100.716-192.791 205.982-193.322 105.266.531 187.495 89.69 205.981 193.322 5.05 28.309 14.097 132.819 1.557 214.876z" />
          </clipPath>
          <g clipPath="url(#dino_hero_svg___clip2)">
            <ellipse
              cx={360.123}
              cy={778.252}
              rx={39.216}
              ry={31.424}
              fill="#fea5a4"
            />
            <ellipse
              cx={393.895}
              cy={732.103}
              rx={14.973}
              ry={14.725}
              fill="#fea5a4"
              transform="matrix(.8931 .22682 -.18934 .74549 179.578 100.094)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.29224 -.21806 .18986 .25445 415.949 644.57)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.80454 .26865 -.30699 .91936 294.222 -426.227)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.48475 .16186 -.14999 .44918 482.961 80.988)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.34226 .10427 -.0859 .28195 504.375 487.89)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(.25025 -.12328 .13025 .2644 398.112 508.517)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(-.06356 .1502 -.17332 -.07334 823.797 676.675)"
            />
            <ellipse
              cx={716.185}
              cy={713.203}
              rx={33.711}
              ry={33.625}
              fill="#fea5a4"
              transform="matrix(-.13102 .09712 -.10695 -.14428 545.206 709.712)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.65235 .75792 -.72807 .62665 687.227 -202.283)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.32492 .3775 -.32718 .2816 599.351 320.652)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.40888 .47506 -.32718 .2816 419.507 74.9)"
            />
            <ellipse
              cx={627.244}
              cy={866.811}
              rx={21.909}
              ry={27.526}
              fill="#fea5a4"
              transform="matrix(.31115 .36151 -.32718 .2816 689.051 282.876)"
            />
            <ellipse
              cx={522.817}
              cy={430.672}
              rx={20.488}
              ry={28.446}
              fill="#fea5a4"
              transform="matrix(1 0 0 1 -16.955 23.774)"
            />
            <ellipse
              cx={451.534}
              cy={438.87}
              rx={15.874}
              ry={8.198}
              fill="#fea5a4"
              transform="rotate(-22.303 439.673 456.456)"
            />
          </g>
          <g
            id="dino_hero_svg__leg2"
            transform="matrix(-.84096 .49581 .52805 .88172 1476.84 -1691.14)"
          >
            <ellipse
              cx={2285.77}
              cy={1484.14}
              rx={64.646}
              ry={72.624}
              fill="#fea09d"
            />
            <clipPath id="dino_hero_svg___clip3">
              <ellipse cx={2285.77} cy={1484.14} rx={64.646} ry={72.624} />
            </clipPath>
            <g clipPath="url(#dino_hero_svg___clip3)">
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe908d"
                transform="matrix(-.46607 -.29571 .24567 -.40534 2509.61 1972.71)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe908d"
                transform="matrix(-.10159 -.32994 .32982 -.10397 2120.68 1733.19)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe908d"
                transform="matrix(.27533 -.15508 .16497 .30238 1916.5 1427.13)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe908d"
                transform="matrix(.28717 .15366 -.2183 .4177 2209.66 1060.33)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe908d"
                transform="matrix(.02833 -.22624 .2525 .03238 2114.38 1672.88)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe8e8b"
                transform="matrix(-.35814 -1.52449 1.37263 -.33016 1569.65 2817.76)"
              />
              <path
                d="M290.938 786.582c-1.528 5.579 6.765 17.587 9.96 17.167 3.195-.419 10.311-15.067 7.6-20.128-1.604-2.996-16.547-.736-17.56 2.961z"
                fill="#fd6b67"
                transform="matrix(-1.06768 -1.27488 .82949 -.67716 1996.01 2351.52)"
              />
              <path
                d="M289.567 781.055c-1.432 3.304 4.247 22.147 7.442 21.727 3.195-.42 13.209-13.725 10.498-18.787-1.604-2.995-16.507-6.243-17.94-2.94z"
                fill="#fd6b67"
                transform="matrix(-1.73945 -.10753 .11388 -1.01655 2725.33 2248.36)"
              />
              <path
                d="M289.567 781.055c-1.432 3.304 4.753 21.15 7.948 20.73 3.195-.42 12.703-12.728 9.992-17.79-1.604-2.995-16.507-6.243-17.94-2.94z"
                fill="#fd6b67"
                transform="matrix(-1.49558 .93674 -.53914 -.83272 3125.1 1799.32)"
              />
            </g>
          </g>
          <path
            d="M.072-.109h.705a.027.027 0 01.027.027v.136a.027.027 0 01-.027.027H.072A.027.027 0 01.045.054v-.136a.027.027 0 01.027-.027z"
            fill="#bfb2af"
            fillRule="nonzero"
            transform="matrix(-1277.33 0 0 638.663 958.26 876.9)"
          />
          <g id="dino_hero_svg__arm2">
            <path
              d="M394.3 626.529c-46.095 30.439-32.034 80.597-32.034 104.176 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 82.337-115.833 117.479-104.176z"
              fill="#fe9f9c"
              transform="matrix(.67602 -.96394 .9051 .63476 -492.328 528.388)"
            />
            <g transform="matrix(.67602 -.96394 .9051 .63476 -492.328 528.388)">
              <clipPath id="dino_hero_svg___clip4">
                <path d="M394.3 626.529c-46.095 30.439-32.034 80.597-32.034 104.176 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.444-77.091 82.337-115.833 117.479-104.176z" />
              </clipPath>
              <g clipPath="url(#dino_hero_svg___clip4)">
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8c89"
                  transform="matrix(.39321 .24704 -.29062 .46258 212.856 187.004)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8c89"
                  transform="matrix(.1823 .1438 -.11359 .14399 260.54 530.44)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8c89"
                  transform="matrix(-.1277 .2162 -.24646 -.14557 614.536 599.312)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8c89"
                  transform="matrix(-.07903 .1338 -.1462 -.08635 545.88 617.605)"
                />
              </g>
            </g>
            <g>
              <path
                d="M290.19 783.38c-1.432 3.304 6.048 17.217 9.243 16.797 3.195-.42 10.774-14.929 9.011-17.812-1.763-2.884-16.821-2.288-18.254 1.015z"
                fill="#fc4b48"
                transform="matrix(.39777 -1.01746 .79481 .25877 -314.497 796.224)"
              />
              <path
                d="M290.428 785.087c-1.433 3.304 3.813 16.492 7.008 16.072 3.196-.42 12.525-12.674 9.814-17.736-1.605-2.995-15.39-1.639-16.822 1.664z"
                fill="#fc4b48"
                transform="matrix(-.66829 .84487 .64046 .52899 113.801 46.493)"
              />
              <path
                d="M291.975 790.144c-1.184 3.423 4.119 13.177 8.347 12.549 3.189-.474 9.937-15.981 7.226-21.043-1.605-2.996-14.091 4.211-15.573 8.494z"
                fill="#fc4b48"
                transform="matrix(-.72531 .7952 .59712 .57879 145.824 33.409)"
              />
            </g>
          </g>
          <g id="dino_hero_svg__arm1">
            <path
              d="M414.31 597.512c4.131 7.035-29.991 21.746-37.841 40.057-14.467 33.749-14.203 77.694-14.203 93.136 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.297-51.519 18.731-105.565 58.748-128.41 23.331-13.319 71.27-17.508 78.741-4.783z"
              fill="#fea09d"
              transform="scale(-1.17736 1.17736) rotate(-81.034 -172.81 1146.987)"
            />
            <g transform="scale(-1.17736 1.17736) rotate(-81.034 -172.81 1146.987)">
              <clipPath id="dino_hero_svg___clip5">
                <path d="M414.31 597.512c4.131 7.035-29.991 21.746-37.841 40.057-14.467 33.749-14.203 77.694-14.203 93.136 0 23.579-19.143 42.723-42.722 42.723-23.58 0-42.526-19.145-42.723-42.723-.297-51.519 18.731-105.565 58.748-128.41 23.331-13.319 71.27-17.508 78.741-4.783z" />
              </clipPath>
              <g clipPath="url(#dino_hero_svg___clip5)">
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8d8a"
                  transform="matrix(-.09857 .60165 .5134 .08411 33.324 115.917)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8d8a"
                  transform="matrix(.16855 .18413 .1985 -.1817 106.803 598.18)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8d8a"
                  transform="matrix(-.2535 .19027 .23636 .31491 310.221 380.56)"
                />
                <ellipse
                  cx={716.185}
                  cy={713.203}
                  rx={33.711}
                  ry={33.625}
                  fill="#fe8d8a"
                  transform="matrix(-.1859 .13953 .13428 .1789 392.435 480.627)"
                />
              </g>
            </g>
            <g>
              <path
                d="M290.19 783.38c-1.432 3.304 6.048 17.217 9.243 16.797 3.195-.42 10.774-14.929 9.011-17.812-1.763-2.884-16.821-2.288-18.254 1.015z"
                fill="#fd5d5a"
                transform="matrix(.10657 -1.09135 -.87897 -.10886 1208.94 1104.142)"
              />
              <path
                d="M290.428 785.087c-1.433 3.304 3.813 16.492 7.008 16.072 3.196-.42 12.525-12.674 9.814-17.736-1.605-2.995-15.39-1.639-16.822 1.664z"
                fill="#fd5d5a"
                transform="matrix(.23285 1.052 -.86096 .202 1158.93 241.65)"
              />
              <path
                d="M291.975 790.144c-1.184 3.423 4.119 13.177 8.347 12.549 3.189-.474 9.937-15.981 7.226-21.043-1.605-2.996-14.091 4.211-15.573 8.494z"
                fill="#fd5d5a"
                transform="matrix(.31074 1.03169 -.84348 .2657 1134.717 216.01)"
              />
            </g>
          </g>
          <g id="dino_hero_svg__face">
            <path
              d="M2114.22 1019.91c5.94 2.22 13.8-1.92 13.82-1 .12 5.43-6.6 13.16-11.82 16.13l-2-15.13z"
              transform="matrix(1.05417 -.1242 .11834 1.00438 -1691.544 -211.082)"
            />
            <circle
              cx={427.545}
              cy={531.3}
              r={27.325}
              transform="matrix(1.04713 .02618 -.02618 1.04713 201.073 -2.2)"
            />
            <circle
              cx={437.886}
              cy={527.93}
              r={10.341}
              fill="#fff"
              transform="matrix(1.04713 .02618 -.02618 1.04713 202.131 -3.426)"
            />
            <g>
              <path
                d="M2114.22 1019.91c5.94 2.22 13.8-1.92 13.82-1 .12 5.43-6.6 13.16-11.82 16.13l-2-15.13z"
                transform="matrix(-1.01988 -.29419 -.2735 .94816 2829.138 176.559)"
              />
              <circle
                cx={427.545}
                cy={531.3}
                r={27.325}
                transform="matrix(1.04713 .02618 -.02618 1.04713 -21.324 -26.094)"
              />
              <circle
                cx={437.886}
                cy={527.93}
                r={10.341}
                fill="#fff"
                transform="matrix(1.04713 .02618 -.02618 1.04713 -20.67 -27.636)"
              />
            </g>
            <g>
              <path
                d="M1183.13 1068.83c10.1 18.11 23.27 25.17 37.31 27.13 12.59 1.76 26.26-.8 39.92-3.9 12.02-2.73 24.02-5.95 35.34-5.89 11.73-.06 23.93 3.56 36.26 6.56 13.84 3.36 27.81 6.05 41.29 3.82 13.79-2.28 27.42-9.57 39.64-27.14.98-1.35.26-3.03-1.62-3.74-1.87-.71-4.2-.19-5.18 1.17-11.29 14.87-22.84 21.25-34.83 22.94-11.82 1.67-23.8-1.22-35.76-4.36-13.45-3.52-26.88-7.39-39.78-7.49-12.43.03-25.67 3.37-38.78 6.57-11.92 2.91-23.7 5.74-34.85 4.52-11.91-1.31-22.71-7.33-32.21-22.29-.8-1.34-2.97-1.96-4.83-1.38-1.86.57-2.72 2.14-1.92 3.48z"
                fill="#b64646"
                transform="matrix(-.5097 -.05939 -.08222 .70566 1269.43 -111.227)"
              />
            </g>
          </g>
          <g
            id="dino_hero_svg__leg1"
            transform="matrix(.78313 .688 -.6853 .7679 -84.242 -1943.88)"
          >
            <ellipse
              cx={2285.77}
              cy={1484.14}
              rx={64.646}
              ry={72.624}
              fill="#fea19e"
            />
            <clipPath id="dino_hero_svg___clip6">
              <ellipse cx={2285.77} cy={1484.14} rx={64.646} ry={72.624} />
            </clipPath>
            <g clipPath="url(#dino_hero_svg___clip6)">
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe918e"
                transform="matrix(-.17957 -.5832 .48024 -.1514 2136.46 2020.09)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe918e"
                transform="matrix(-.10159 -.32994 .32982 -.10397 2157.41 1737.49)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe918e"
                transform="matrix(.1771 -.04934 .06119 .22484 2094.43 1415.17)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe918e"
                transform="matrix(.28717 .15366 -.2183 .4177 2180.72 1059.99)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe918e"
                transform="matrix(.03753 -.29964 .21905 .02809 2140.37 1672.18)"
              />
              <ellipse
                cx={716.185}
                cy={713.203}
                rx={33.711}
                ry={33.625}
                fill="#fe8f8c"
                transform="matrix(-.35814 -1.52449 1.37263 -.33016 1561.58 2823.87)"
              />
              <path
                d="M290.938 786.582c-1.528 5.579 6.765 17.587 9.96 17.167 3.195-.419 10.311-15.067 7.6-20.128-1.604-2.996-16.547-.736-17.56 2.961z"
                fill="#fd6c68"
                transform="matrix(-1.6394 -.47027 .26911 -1.00886 2581.66 2357.53)"
              />
              <path
                d="M289.567 781.055c-1.432 3.304 4.247 22.147 7.442 21.727 3.195-.42 13.209-13.725 10.498-18.787-1.604-2.995-16.507-6.243-17.94-2.94z"
                fill="#fd6c68"
                transform="matrix(-1.43734 .92612 -.56565 -.87428 3136.95 1832.21)"
              />
              <path
                d="M289.567 781.055c-1.432 3.304 4.753 21.15 7.948 20.73 3.195-.42 12.703-12.728 9.992-17.79-1.604-2.995-16.507-6.243-17.94-2.94z"
                fill="#fd6c68"
                transform="matrix(-.7834 1.53119 -.90745 -.46075 3179.91 1356.52)"
              />
            </g>
          </g>
          <g>
            <path
              d="M541.963 383.304c-5.354 12.895 22.116 52.871 31.924 47.368s38.325-57.88 20.851-79.12c-10.476-12.734-46.086 15.641-52.775 31.752z"
              fill="#fd6a66"
              transform="matrix(-1.1296 -.1897 -.18776 1.11803 1258.51 60.224)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgDinoHero;
